<s1-input-label [label]="label">
  <input
    type="text"
    class="form-control"
    [ngClass]="{'is-invalid' : !isValid }"
    [formControl]="control"
    [typeahead]="dataSource"
    (typeaheadLoading)="changeTypeaheadLoading($event)"
    (typeaheadNoResults)="changeTypeaheadNoResults($event)"
    (typeaheadOnSelect)="typeaheadOnSelect($event)"
    [typeaheadWaitMs]="300"
    [typeaheadOptionsLimit]="100"
    [typeaheadOptionField]="'codice'"
    [typeaheadItemTemplate]="template"
    [readonly]="readonly" />
  @if (withButtonList && !readonly) {
    <div class="input-group-append">
      <button type="button" class="btn btn-outline-primary" (click)="standardSearchModal.open(config.standardSearch)">
        <i class="fa fa-list"></i>
      </button>
    </div>
  }
</s1-input-label>

<!-- Modal Search -->
<s1-standard-search-modal #standardSearchModal (elementSelected)="elementSelectedOnStandardSearchModal($event)"></s1-standard-search-modal>

<!-- Autocomplete Standard list template-->
<ng-template #templateStandard let-item="item">
  <h5>{{ item.codice }} - {{item.descrizione}}</h5>
</ng-template>
